// extracted by mini-css-extract-plugin
export default {"container":"BidNowInfo_container__J4z0q","textBox":"BidNowInfo_textBox__rrd-6","message":"BidNowInfo_message__JVbHW"};